import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../utils/axios";

const initialState = {
  loading: false,
  checkCustomerDetailsData: {},
  error: "",
  success: false,
  status: "",
};

const fetchCustomerDetails = createAsyncThunk(
  "check/customer",
  async (mobile) => {
    
    try {
      const result = await axios.get(
        `https://apac.api.capillarytech.com/mobile/v2/api/customers/lookup/customerDetails?mobileNumber=${mobile}`
      );

      return result?.data;
    } catch (err) {
      console.log(err);
    }
  }
);

const customerDetailsSlice = createSlice({
  name: "check-customer",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(fetchCustomerDetails.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchCustomerDetails.fulfilled, (state, action) => {
    
      state.loading = false;
      state.checkCustomerDetailsData =
        action?.payload?.profiles && action?.payload?.profiles[0];
      state.success = action?.payload.hasOwnProperty("errors")
        ? action?.payload?.errors[0]?.status
        : true;
      state.error = action?.payload.hasOwnProperty("errors")
        ? action?.payload?.errors[0]?.message
        : "";
    });
    builder.addCase(fetchCustomerDetails.rejected, (state, action) => {
      state.loading = false;
      state.checkCustomerDetailsData = [];
      state.error = action.error.message;
    });
  },
});

export default customerDetailsSlice.reducer;
export { fetchCustomerDetails };
